const portfolioMarketValueCopy = {
  errorMessage: 'Portfolio market value cannot be generated at this time.',
  title: 'Market Value',
  warningMessage:
    'There are no positions associated with your portfolio at this time.'
};

export default portfolioMarketValueCopy;
